import { forwardRef } from 'react';
import { Pencil } from 'lucide-react';
import {
  ActionIcon,
  createPolymorphicComponent,
  Tooltip,
  type ActionIconProps,
} from '@mantine/core';

interface ActionEditButtonProps extends ActionIconProps {
  label?: string;
}

const C = forwardRef<HTMLButtonElement, ActionEditButtonProps>(
  ({ children = <Pencil size={20} />, label = 'Ubah', ...props }, ref) => {
    return (
      <Tooltip label={label}>
        <ActionIcon variant="light" size={36} {...props} ref={ref}>
          {children}
        </ActionIcon>
      </Tooltip>
    );
  }
);

C.displayName = 'ActionEditButton';

export const ActionEditButton = createPolymorphicComponent<'button', ActionEditButtonProps>(C);
